export default "__VITE_ASSET__73425e9b__"